export default __webpack_public_path__ + "src/images/time_font-5a77c0.xml";